/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BulkMoveFolderDocumentsRequest
 */
export interface BulkMoveFolderDocumentsRequest {
  /**
   * フォルダに移動する資料IDリスト
   * @type {Array<string>}
   * @memberof BulkMoveFolderDocumentsRequest
   */
  ids: Array<string>
  /**
   *
   * @type {string}
   * @memberof BulkMoveFolderDocumentsRequest
   */
  folderId: string
}

export function BulkMoveFolderDocumentsRequestFromJSON(json: any): BulkMoveFolderDocumentsRequest {
  return BulkMoveFolderDocumentsRequestFromJSONTyped(json, false)
}

export function BulkMoveFolderDocumentsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkMoveFolderDocumentsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    ids: json['ids'],
    folderId: json['folder_id']
  }
}

export function BulkMoveFolderDocumentsRequestToJSON(value?: BulkMoveFolderDocumentsRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    ids: value.ids,
    folder_id: value.folderId
  }
}
